import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { Title, Meta } from '@angular/platform-browser';
import { VideoCarouselComponent } from '../../components/video-carousel/video-carousel';
import { DataService, LocationInfo } from '../../services/data';
import { SafeUrlPipe } from '../../pipes/safe-url-pipe';

@Component({
  selector: 'app-locations',
  standalone: true,
  imports: [AsyncPipe, VideoCarouselComponent, SafeUrlPipe],
  template: `
<div class="container mt-4">
  <h1 class="display-4 mb-4 text-center">Our Locations</h1>

  @if (locations$ | async; as locations) {
    @for (loc of locations; track loc.id; let isEven = $even) {
      <div class="row align-items-center mb-5 pb-5 border-bottom">
        <div class="col-lg-6" [class.order-lg-2]="!isEven">
          <h2 class="h1 mb-3">{{ loc.name }}</h2>
          <p class="lead mb-4">{{ loc.description }}</p>

          <div class="card shadow-sm mb-4">
            <div class="ratio ratio-16x9">
              <iframe [src]="loc.mapUrl | safeUrl" allowfullscreen="" loading="lazy"></iframe>
            </div>
          </div>
        </div>

        <div class="col-lg-6" [class.order-lg-1]="!isEven">
          <div class="p-3 bg-light rounded shadow-sm">
            <app-video-carousel [items]="loc.gallery"></app-video-carousel>
          </div>
        </div>
      </div>
    }
  } @else {
    <div class="text-center my-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Fetching locations...</p>
    </div>
  }
</div>
  `,
  styles: `
    .ratio iframe {
      border: 0;
    }
  `,
})
export class Locations {
  locations$: Observable<LocationInfo[]>;

  constructor(private dataService: DataService, private titleService: Title, private metaService: Meta) {
    this.locations$ = this.dataService.getLocations();
    this.titleService.setTitle('Locations - RentMU.com');
    this.metaService.updateTag({ name: 'description', content: 'Explore our student housing locations near University of Missouri, including Rock Bridge Estates and Windsor Place.' });
  }
}
